const updatesData = [
  { time: '10分钟前', title: '某综艺录制现场突发状况，嘉宾情绪失控中途离场', source: '现场观众投稿' },
  { time: '28分钟前', title: '热门IP改编剧换角传闻获多方侧面印证', source: '业内人士透露' },
  { time: '1小时前', title: '知名音乐人新专辑遭泄露，工作室紧急发布声明', source: '平台爆料' },
  { time: '2小时前', title: '跨年晚会阵容初步曝光，多位大咖确认加盟', source: '内部消息' },
  { time: '3小时前', title: '某品牌与代言人解约细节曝光，违约金数额惊人', source: '深度调查' },
  { time: '4小时前', title: '短视频平台头部创作者合约到期，去向引发猜测', source: '多方求证' },
  { time: '5小时前', title: '古装大制作剧组被曝拖欠工资，制片方暂无回应', source: '匿名爆料' },
  { time: '7小时前', title: '知名导演新片选角标准流出，引发圈内广泛讨论', source: '行业资讯' },
  { time: '9小时前', title: '某电商主播税务问题调查有新进展，官方即将通报', source: '权威信源' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">最新动态</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">实时追踪热点爆料，不错过任何精彩内容</p>

        <div className="relative pl-6 md:pl-8">
          <div className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-0.5 bg-background-300"></div>
          <div className="space-y-6">
            {updatesData.map((item, i) => (
              <div key={i} className="relative">
                <div className={`absolute -left-[25px] md:-left-[33px] top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background-100 ${
                  i < 3 ? 'bg-primary-500 border-primary-500' : 'bg-background-300 border-background-300'
                }`}></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap font-medium">{item.time}</span>
                  <p className="text-sm md:text-base text-foreground-800 font-medium flex-1">{item.title}</p>
                  <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap self-start sm:self-auto">{item.source}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}